module.exports = __webpack_public_path__ + "static/media/nu.4a4641b3.svg";